// src/components/list/FeelingRoomSensor.tsx

import { MemoryTwoTone, TroubleshootTwoTone } from '@mui/icons-material'
import {
  Avatar,
  Collapse,
  Divider,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Tooltip,
} from '@mui/material'

import { FolderId, SensorRecord, SensorId } from '@/types/domain'

import { ToggleDateType } from '..'
import { sensorType } from '../../api'
import { useFeelingSensors, useSensorIcon } from '../../hooks'

type FeelingRoomSensorProps = {
  id: FolderId
  onClick: () => void
  sensorId: SensorId
}

export const FeelingRoomSensor = ({
  id: fId,
  onClick,
  sensorId: sId,
}: FeelingRoomSensorProps) => {
  const fSensors: SensorRecord[] = useFeelingSensors(fId)
  const fRecord: SensorRecord = fSensors.find(f => f.entity_id === sId)

  const {
    sensor_type,
    status,
    sub_sensor_target: sst,
    time,
    type_in_folder,
    value,
    unit,
  } = fRecord ?? {}

  const image_url = useSensorIcon(sId, status)
  const hrType = sensorType(sensor_type, type_in_folder, sst)
  const hrUnit: string = unit ?? ''
  const timestamp: Date = new Date(Date.parse(time))

  return fSensors.length === 0 ? null : (
    <Collapse in={true}>
      <ListItem>
        <ListItemAvatar>
          <Avatar src={image_url} sx={{ width: 40, height: 40 }}>
            {!image_url && <MemoryTwoTone />}
          </Avatar>
        </ListItemAvatar>

        <ListItemText
          primary={hrType}
          secondary={<ToggleDateType date={timestamp} />}
          sx={{ width: 0.7 }}
        />

        <ListItemText
          disableTypography
          primary={`${value} ${hrUnit}`}
          sx={{
            display: 'flex',
            fontWeight: 'bold',
            justifyContent: 'flex-end',
            mr: 2,
            width: 0.3,
          }}
        />

        <Divider flexItem orientation={'vertical'} sx={{ mr: 2 }} />

        <Tooltip title={`Details ${hrType}`}>
          <IconButton onClick={onClick}>
            <TroubleshootTwoTone />
          </IconButton>
        </Tooltip>
      </ListItem>
    </Collapse>
  )
}
